var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Loader from "../Loader";
import { styleBlock } from "../styleBlock";
export default (props) => {
    const { className, variant = "light", children, loader, loading, text } = props, rest = __rest(props, ["className", "variant", "children", "loader", "loading", "text"]);
    const classNames = styleBlock("loader-overlay");
    return (React.createElement("div", Object.assign({ className: classNames({ loading }).mix(className) }, rest),
        loading && (React.createElement("div", { className: classNames("overlay", { [variant]: true }) },
            React.createElement("div", { className: classNames("loader") }, loader ? loader : React.createElement(Loader, null)),
            text && React.createElement("div", { className: classNames("text") }, text))),
        children));
};
//# sourceMappingURL=index.js.map